import styled from 'styled-components'

export const MaturedWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 30px;
  justify-items: center;

  .spinner_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .no_investment_img {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    p {
      padding-left: 20px;
    }
  }
`
export const Wrap = styled.div`
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 100%;
  }
`
export const ToggleWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  margin-top: 1rem;
  .wrap {
    display: flex;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 100%;
    }
  }

  .btn {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: ${({ theme }) => theme.colors.AccountDark};
    width: 153px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
      font-size: 14px;
    }
  }

  .btn.active-btn {
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: 0px 0px 1px rgba(40, 41, 61, 0.08),
      0px 0.5px 2px rgba(96, 97, 112, 0.16);
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: ${({ theme }) => theme.colors.Btnprimary};
    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
      font-size: 14px;
    }
  }

  .content {
    display: none;
  }

  .content.active-content {
    display: block;
  }
`

export const InvestmentOption = styled.div``
